var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Confirmation',{attrs:{"title":"Formulaire soumis","idFacture":_vm.idFacture,"hideAppbar":_vm.hideAppbar,"message":_vm.message}},[_c('ressource',{attrs:{"code":"formulaire-soumis"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }